var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "shadow-none mb-3",
    attrs: {
      "header-bg-variant": "light",
      "header-class": "p-3"
    }
  }, [_c('div', {
    staticClass: "message-flex"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "image mr-4"
  }, [_c('b-card', {
    staticClass: "m-3 flex-button rounded-lg",
    staticStyle: {
      "backgroundcolor": "#fffff9"
    },
    attrs: {
      "no-body": ""
    }
  }, [_vm.form.tag_title ? _c('span', {
    staticClass: "custom-badge altText"
  }, [_vm._v(" " + _vm._s(_vm.form.tag_title) + " ")]) : _vm._e(), !_vm.onlyImage ? [_c('div', {
    staticClass: "image-frame"
  }, [_c('b-img', {
    attrs: {
      "center": "",
      "src": _vm.imgSrc
    }
  })], 1)] : _vm._l(_vm.form.footer_contents, function (a, adx) {
    return _c('div', {
      key: adx,
      staticClass: "image-frame",
      style: {
        aspectRatio: "".concat(a.area.width, "/").concat(a.area.height)
      }
    }, [_c('a', {
      attrs: {
        "href": a.uri ? a.uri : '#',
        "target": a.uri ? '_blank' : '_self',
        "title": a.label
      }
    }, [a.img_url ? _c('b-img', {
      attrs: {
        "center": "",
        "src": a.img_url,
        "alt": a.label
      }
    }) : _vm._e()], 1)]);
  }), !_vm.onlyImage ? _c('div', {
    staticClass: "p-3 body"
  }, [_c('h4', {
    staticClass: "lg font-weight-bold text-center mb-0",
    staticStyle: {
      "color": "#de006f"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.title || "頁面標題") + " ")])]) : _vm._e(), _c('div', {
    staticClass: "footer p-0"
  }, _vm._l(_vm.form.footer_contents.filter(function (x) {
    return x.type == 'button';
  }), function (f, fdx) {
    return _c('div', {
      key: fdx
    }, [f.label != '' ? _c('b-button', {
      staticClass: "m-0 p-2",
      attrs: {
        "href": f.uri,
        "variant": "link",
        "target": "_blank",
        "block": ""
      }
    }, [_vm._v(" " + _vm._s(f.label) + " ")]) : _vm._e()], 1);
  }), 0)], 2)], 1), _c('div', {
    staticClass: "flex-fill"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("*頁面標題")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "輸入標題",
      "maxlength": "20",
      "state": _vm.v$.form.title.$error ? false : null,
      "required": "",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("*起始時間")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates,
      "disabled": _vm.isReadonly || _vm.doesInProgress()
    },
    model: {
      value: _vm.startAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "date", $$v);
      },
      expression: "startAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadonly || _vm.doesInProgress()
    },
    model: {
      value: _vm.startAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.startAt, "time", $$v);
      },
      expression: "startAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.time.HH.$error || !_vm.v$.startAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("*結束時間")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.startAt.$invalid
      },
      "disabledDates": _vm.disabledDates,
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.endAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "date", $$v);
      },
      expression: "endAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.startAt.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.startAt.time.HH.$error || _vm.v$.startAt.time.mm.$error || _vm.v$.startAt.date.beforeEndAt.$invalid
      }],
      "disabled": _vm.isReadonly
    },
    model: {
      value: _vm.endAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.endAt, "time", $$v);
      },
      expression: "endAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.endAt.time.HH.$error || !_vm.v$.endAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("*順序")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "輸入順序",
      "min": "1",
      "maxlength": "20",
      "state": _vm.v$.form.order.$error ? false : null,
      "required": "",
      "readonly": _vm.isReadonly
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.order.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), _c('hr'), _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "text-muted small col-10 mb-3"
  }, [_vm._v(" 請注意：不同高度的圖卡於同時間啟用會導致跑版 ")])]), _c('div', {
    staticClass: "form-group row justify-content-end"
  }, _vm._l([2048, 1588], function (ht) {
    return _c('div', {
      key: ht,
      staticClass: "col-sm-5"
    }, [_c('div', {
      staticClass: "card shadow-none rounded-3 h-100"
    }, [_c('div', {
      staticClass: "card-header p-2 text-center bg-light"
    }, [_vm._v(" 高：" + _vm._s(ht) + " ")]), _c('div', {
      staticClass: "p-2 d-flex justify-content-around align-items-stretch"
    }, _vm._l(_vm.typeTemplate.filter(function (x) {
      return x.baseSize.height == ht;
    }), function (i) {
      return _c('label', {
        key: i.type,
        staticClass: "template d-flex flex-column",
        attrs: {
          "for": "templateRadio".concat(i.type),
          "role": "button"
        }
      }, [_c('div', {
        staticClass: "text-center mb-2"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "id": "templateRadio".concat(i.type),
          "disabled": _vm.isReadonly
        },
        domProps: {
          "value": i.type,
          "checked": _vm.form.type == i.type
        },
        on: {
          "change": function change($event) {
            return _vm.switchType($event, i);
          }
        }
      })]), _c('div', {
        staticClass: "border d-flex flex-column flex-fill"
      }, [_vm._l(i.type == 40 || i.type == 80 ? i.actions.slice(0, 1) : i.actions, function (j, jdx) {
        return _c('div', {
          key: jdx,
          staticClass: "\n                        bg-secondary\n                        img\n                        d-flex\n                        justify-content-center\n                        align-items-center\n                      ",
          style: {
            minHeight: "".concat(i.type == 40 || i.type == 80 ? 768 / i.baseSize.height * 100 : j.area.height / i.baseSize.height * 100, "%"),
            aspectRatio: i.type == 40 || i.type == 80 ? '4/3' : "".concat(j.area.width, "/").concat(j.area.height)
          }
        }, [_c('span', {
          staticClass: "font-weight-bold text-white"
        }, [_vm._v(_vm._s(["A", "B", "C", "D"][jdx]))])]);
      }), i.type == 40 || i.type == 80 ? _c('div', {
        staticClass: "\n                        flex-fill\n                        p-1\n                        d-flex\n                        flex-column\n                        justify-content-around\n                      "
      }, _vm._l(i.type / 10, function (b) {
        return _c('div', {
          key: b,
          staticClass: "border"
        });
      }), 0) : _vm._e()], 2)]);
    }), 0)])]);
  }), 0), _vm.currentTemplate.type == 40 || _vm.currentTemplate.type == 80 ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label text-right"
  }, [_vm._v("*圖片")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm.imgSrc ? _c('div', {
    staticClass: "s-image-list-item s-draggable"
  }, [_c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.imgSrc
    }
  }), !_vm.isReadonly ? _c('button', {
    staticClass: "btn btn-danger s-delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.deleteImage();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "s-image-list-item mr-3"
  }, [_c('ImageSelector', {
    attrs: {
      "aspect-ratio": 4 / 3
    },
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" 圖片 ")])];
      }
    }], null, false, 998030558)
  })], 1), _c('ul', _vm._l(_vm.currentTemplate.descriptions, function (d, ddx) {
    return _c('li', {
      key: ddx
    }, [_vm._v(" " + _vm._s(d) + " ")]);
  }), 0)]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.imgSrc.$error
    }
  }, [_vm._v(" 請上傳圖片 ")])], 1)]) : _vm._e(), _vm._l(_vm.form.footer_contents, function (f, fdx) {
    return _c('div', {
      key: fdx
    }, [_c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(f.type == "uri" ? ["A", "B", "C", "D"][fdx] : "\u52D5\u4F5C".concat(fdx + 1)) + " ")]), _c('div', {
      staticClass: "col-sm-10"
    }, [f.type == 'uri' ? _c('div', {
      staticClass: "mb-3"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [f.img_url ? _c('div', {
      staticClass: "s-image-list-item s-draggable mr-4"
    }, [_c('img', {
      staticClass: "s-cropped-image",
      attrs: {
        "src": f.img_url
      }
    }), !_vm.isReadonly ? _c('button', {
      staticClass: "btn btn-danger s-delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click(x) {
          f.img_url = null;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times m-0"
    })]) : _vm._e()]) : _c('div', {
      staticClass: "s-image-list-item mr-4"
    }, [_c('ImageSelector', {
      attrs: {
        "aspect-ratio": f.area.width / f.area.height
      },
      on: {
        "input": function input($event) {
          return _vm.selectImage($event, f);
        }
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function fn(_ref2) {
          var openFileSelector = _ref2.openFileSelector;
          return [_c('button', {
            staticClass: "btn s-trigger-btn",
            on: {
              "click": openFileSelector
            }
          }, [_c('i', {
            staticClass: "fa fa-plus"
          }), _vm._v(" 圖片 ")])];
        }
      }], null, true)
    })], 1), _c('ul', {
      staticClass: "mb-0"
    }, _vm._l(_vm.currentTemplate.descriptions, function (d, ddx) {
      return _c('li', {
        key: ddx
      }, [_vm._v(" " + _vm._s(d) + " ")]);
    }), 0)]), _c('b-form-invalid-feedback', {
      attrs: {
        "state": _vm.v$.form.footer_contents.$dirty && _vm.v$.form.footer_contents.$each.$response.$data[fdx].img_url.$error ? false : null
      }
    }, [_vm._v(" 請上傳圖片 ")])], 1) : _vm._e(), _c('div', {
      staticClass: "mb-3"
    }, [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "placeholder": "輸入動作標籤的說明",
        "maxlength": "15",
        "required": "",
        "state": _vm.v$.form.footer_contents.$dirty && _vm.v$.form.footer_contents.$each.$response.$data[fdx].label.$error ? false : null,
        "readonly": _vm.isReadonly
      },
      model: {
        value: f.label,
        callback: function callback($$v) {
          _vm.$set(f, "label", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "f.label"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": _vm.v$.form.footer_contents.$dirty && _vm.v$.form.footer_contents.$each.$response.$data[fdx].label.$error ? false : null
      }
    }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
      staticClass: "mb-3"
    }, [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "placeholder": "輸入網址",
        "required": "",
        "readonly": _vm.isReadonly,
        "state": _vm.v$.form.footer_contents.$dirty && _vm.v$.form.footer_contents.$each.$response.$data[fdx].uri.$error ? false : null
      },
      model: {
        value: f.uri,
        callback: function callback($$v) {
          _vm.$set(f, "uri", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "f.uri"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": _vm.v$.form.footer_contents.$dirty && _vm.v$.form.footer_contents.$each.$response.$data[fdx].uri.$error ? false : null
      }
    }, [_vm._v(" 此欄位為必填 ")])], 1)])])]);
  })], 2)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }